<div class="page_wrapper">
  <app-header-new></app-header-new>

  <div class="container-fluid wrapper-page header-fix position-relative display-contents">
    <div align="center">
      <h2 class="mt-4 mb-4 text-color font-size-25 font-weight-500">
        ONLINE DOCTOR APPOINTMENT
      </h2>
    </div>
    <div class="row justify-content-center" *ngIf="physician">
      <div class="col-lg-10">
        <div class="card m-b-30">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-3">
                <!-- <div class="card m-b-30 border-0"> -->
                <!-- <img [src]="physician?.ppurl" class="w-100 h-100" /> -->
                <img [src]="physician?.ppurl" class="image" />
                <!-- </div> -->
              </div>
              <div class="col-md-6 detail-tbl">
                <h3 class="text-color font-size-20 text-capitalize">
                  {{ physician?.title ? physician?.title : defaultDr }}
                  {{ physician?.first_name }}
                  {{ physician?.last_name }} {{ physician?.qualification }}
                </h3>
                <table class="table">
                  <tbody>
                    <tr>
                      <td class="text-color-font font-size-16 pl-0 border-0">
                        Speciality
                      </td>
                      <td class="text-change font-size-16 font-weight-500 border-0">
                        {{ physician_model?.speciality }}
                      </td>
                    </tr>
                    <!--<tr>
                      <td class="text-color-font font-size-16 pl-0 border-0">Education</td>
                      <td class="text-change  font-size-16 font-weight-500 border-0"> {{physician_model?.education}}
                      </td>
                    </tr> -->
                    <tr>
                      <td class="text-color-font font-size-16 pl-0 border-0">
                        University
                      </td>
                      <td class="text-change font-size-16 font-weight-500 border-0">
                        {{ physician_model?.university }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-color-font font-size-16 pl-0 border-0">
                        Location
                      </td>
                      <td class="text-change font-size-16 font-weight-500 border-0">
                        {{ physician?.city }}{{ physician_model?.location }}
                      </td>
                    </tr>
                    <tr *ngIf="
                        physician.qualification &&
                        physician.physician_qualification[0].r_no
                      ">
                      <td class="text-color-font font-size-16 pl-0 border-0">
                        Registration No.
                      </td>
                      <td class="text-change font-size-16 font-weight-500 border-0">
                        {{ physician.physician_qualification[0].r_no }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="rating-color rating-wrap cursor mb-3">
                  <!-- <star-rating
                    value="{{ physician?.ratings?.total_rating }}"
                    [checkedcolor]="feedbackColors?.CHECKED"
                    [uncheckedcolor]="feedbackColors?.UNCHECKED"
                    [size]="starSize"
                    readonly="true"
                  ></star-rating> -->
                  <ngb-rating style="font-size: 1.5rem" class="bi-star-fill" [max]="5"
                    [rate]="physician?.ratings?.total_rating" [readonly]="true"></ngb-rating>
                  <span class="text-color ml-2">({{ physician?.ratings?.total_count }} Ratings)</span>
                </div>
              </div>
              <div class="col-md-3">
                <div class="d-flex flex-column h-100">
                  <div class="mb-auto" *ngIf="physician?.status">
                    <a class="btn btn-success button-color text-light btn-rounded btn-xs ml-auto mb-3">Online</a>
                  </div>
                  <div class="mb-auto" *ngIf="physician?.verified">
                    <i class="fa fa-check-circle checkbox-color" aria-hidden="true"></i>
                    <span class="text-muted font-weight-italic font-size-16 ml-2">Verified</span>
                  </div>
                  <div class="mb-3">
                    <p class="font-size-12 mb-1 text-change">Share Doctor</p>

                    <div class="icon-column">
                      <a class="circle" style="background-color: #4267b2" (click)="shareProfile($event, 'facebook')">
                        <img class="facebook-icon" src="../../../assets/images/facebook-f.svg" />
                      </a>
                      <a class="circle" style="background-color: #1da1f2" (click)="shareProfile($event, 'twitter')">
                        <img class="icon" src="../../../assets/images/twitter.svg" />
                      </a>
                      <a class="circle" style="background-color: #0077b5" (click)="shareProfile($event, 'linkedin')">
                        <img class="icon" src="../../../assets/images/linkedin.svg" />
                      </a>
                      <a class="circle" style="background-color: #e60023" (click)="shareProfile($event, 'pinterest')">
                        <img class="icon" src="../../../assets/images/pinterest.svg" />
                      </a>
                      <a class="circle" style="background-color: #ff961c" (click)="shareProfile($event, 'mail')">
                        <img class="icon" src="../../../assets/images/envelope-solid.svg" />
                      </a>
                      <a class="circle" style="background-color: #25d366" (click)="shareProfile($event, 'whatsapp')">
                        <img class="icon" src="../../../assets/images/whatsapp.svg" />
                      </a>
                    </div>
                    <!-- <share-buttons
                      theme="circles"
                      [include]="[
                        'facebook',
                        'twitter',
                        'linkedin',
                        'pinterest',
                        'email',
                        'whatsapp'
                      ]"
                      [size]="-4"
                    >
                    </share-buttons> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" *ngIf="physician">
      <div class="col-lg-10">
        <div class="card m-b-30">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-7">
                <form [formGroup]="patientForm">
                  <fieldset [disabled]="
                      appointment?.schedule_stat &&
                      appointment?.schedule_stat !== 'pending'
                    ">
                    <h2 class="text-color text-left font-size-25 font-weight-500">
                      BOOK APPOINTMENT<small
                        class="text-change font-size-14 font-weight-500 ml-0 ml-md-3 d-inline-block d-lg-initial">CONSULTATION
                        CHARGES ₹ {{ physician?.consult_fee }} (20
                        mins)</small>
                    </h2>
                    <p class="text-change font-size-14">
                      Please fill out the appointment request form and we'll get
                      back to you at the earliest.
                    </p>
                    <div class="row pt-3">
                      <div class="col-md-6">
                        <label for="name" class="text-change font-weight-500">First Name<span
                            class="text-danger">*</span></label>
                        <input class="form-control" type="text" formControlName="first_name" maxLength="30" required />
                        <!-- <div *ngIf="
                            patientForm.get('first_name').hasError('required')
                          " class="invalid-feedback">
                          First Name is required
                        </div>
                        <div *ngIf="
                            patientForm.get('first_name').hasError('pattern')
                          " class="invalid-feedback">
                          First Name is invalid
                        </div> -->
                        <div class="text-danger"
                          *ngIf="  patientForm.get('first_name').touched && patientForm.get('first_name').invalid">
                          *First name is required & should be alpahbets only
                        </div>
                      </div>
                      <div class="col-md-6 mt-2 mt-md-0">
                        <label for="name" class="ptext-change font-weight-500">Last Name<span
                            class="text-danger">*</span></label>
                        <input class="form-control" type="text" formControlName="last_name" maxLength="30" required />
                        <!-- <div *ngIf="
                            patientForm.get('last_name').hasError('required')
                          " class="invalid-feedback">
                          Last Name is required
                        </div>
                        <div *ngIf="
                            patientForm.get('last_name').hasError('pattern')
                          " class="invalid-feedback">
                          Last Name is invalid
                        </div> -->
                        <div class="text-danger"
                          *ngIf="  patientForm.get('last_name').touched && patientForm.get('last_name').invalid">
                          *Last name is required & should be alpahbets only
                        </div>
                      </div>
                    </div>
                    <div class="row pt-3">
                      <div class="col-md-6 mt-2 mt-md-0">
                        <label for="name" class="text-change font-weight-500">Your Email<span
                            class="text-danger">*</span></label>
                        <input class="form-control" type="text" formControlName="email_id" maxLength="50"
                          on-focusout="emailvalid(confirmationModal)" required />
                        <!-- <div *ngIf="
                            patientForm.get('email_id').hasError('required')
                          " class="invalid-feedback">
                          Email is required
                        </div>
                        <div *ngIf="
                            patientForm.get('email_id').hasError('pattern')
                          " class="invalid-feedback">
                          Email is invalid
                        </div> -->
                        <div class="text-danger"
                          *ngIf="  patientForm.get('email_id').touched && patientForm.get('email_id').invalid">
                          *Enter a valid Email-id for which account activation link
                          will be sent
                        </div>
                      </div>
                      <div class="col-md-6 mt-2 mt-md-0">
                        <label for="name" class="text-change font-weight-500">Confirm Email<span
                            class="text-danger">*</span></label>
                        <input class="form-control" type="text" formControlName="confirm_email" maxLength="50"
                          required />
                        <div class="text-danger"
                          *ngIf="  patientForm.get('confirm_email').touched && patientForm.get('confirm_email').invalid">
                          *confirm-email mismatch with your mail id
                        </div>
                      </div>
                    </div>
                    <div class="row pt-3">
                      <div class="col-md-6">
                        <label for="name" class="text-change font-weight-500">Gender
                          <!-- <span class="text-danger">*</span> -->
                        </label>
                        <select class="form-control" formControlName="gender">
                          <option *ngFor="let g of gender" [value]="g.value">
                            {{ g.key }}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-6">
                        <label for="name" class="text-change font-weight-500">Date of Birth<span
                            class="text-danger">*</span></label>
                        <div class="m-t-10">
                          <div class="d-flex">
                            <input class="form-control" placeholder="Choose a date(DD/MM/YYYY)" name="dob"
                              formControlName="dob" ngbDatepicker #ed="ngbDatepicker" data-date-inline-picker="false"
                              id="dob" [minDate]="miniDate" [maxDate]="currentDate" />
                            <div>
                              <button class="btn btn-outline-secondary calendar rounded-0" (click)="ed.toggle()"
                                type="button" style="line-height: 2.5;" id="endDateButton">
                                <span class="fa fa-calendar"></span>
                              </button>
                            </div>
                          </div>
                          <div class="text-danger"
                            *ngIf="  patientForm.get('dob').touched && patientForm.get('dob').invalid">
                            *DOB
                            is
                            required
                          </div>
                          <!-- <div *ngIf="patientForm.get('dob').hasError('required')" class="invalid-feedback"> dob
                            is
                            required
                          </div> -->
                          <!-- <mat-form-field class="w-100">
                            <input matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate"
                              placeholder="Choose a date" formControlName="dob" readonly required />
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                            <mat-error *ngIf="patientForm.get('dob').errors">
                              <div *ngIf="
                                  patientForm.get('dob').hasError('required') &&
                                  !(
                                    patientForm
                                      .get('dob')
                                      .hasError('matDatepickerMax') ||
                                    patientForm
                                      .get('dob')
                                      .hasError('matDatepickerMin') ||
                                    patientForm
                                      .get('dob')
                                      .hasError('matDatepickerParse')
                                  )
                                ">
                                DOB is required
                              </div>
                              <div *ngIf="
                                  patientForm
                                    .get('dob')
                                    .hasError('matDatepickerMax') ||
                                  patientForm
                                    .get('dob')
                                    .hasError('matDatepickerMin')
                                ">
                                DOB is invalid
                              </div>
                            </mat-error>
                          </mat-form-field> -->
                        </div>
                      </div>
                    </div>

                    <div class="row pt-3">
                      <div class="col-md-6">
                        <label for="name" class="text-change font-weight-500">Consultation<span
                            class="text-danger">*</span></label>
                        <select class="form-control" formControlName="type" required>
                          <option *ngFor="let c of consultation" [value]="c.value">
                            {{ c.key }}
                          </option>
                        </select>
                        <!-- OTP is required -->
                        <!-- <div *ngIf="patientForm.get('type').hasError('required')" class="invalid-feedback">
                          Consultation is required
                        </div> -->
                        <div class="text-danger"
                          *ngIf="  patientForm.get('type').touched && patientForm.get('type').invalid">
                          *Consultation is required
                        </div>
                      </div>
                      <div class="col-md-6 mt-2 mt-md-0">
                        <label for="name" class="text-change font-weight-500">Appointment Date<span
                            class="text-danger">*</span></label>
                        <div *ngIf="!isFollowup" class="d-flex">
                          <input class="form-control" placeholder="" name="appointmentDate" formControlName="apdate"
                            ngbDatepicker #appointment="ngbDatepicker" data-date-inline-picker="false"
                            id="appointmentDate" [minDate]="aptinterval" [markDisabled]="isDateDisabled"
                            (dateSelect)="getTimeSlots()" />
                          <div>
                            <button class="btn btn-outline-secondary button-height calendar rounded-0"
                              (click)="appointment.toggle()" type="button" id="AppointmentButton">
                              <img src="/assets/images/cal.png" />
                            </button>
                          </div>
                        </div>
                        <div *ngIf="isFollowup" class="d-flex">
                          <input class="form-control" placeholder="" name="appointmentDate" formControlName="apdate"
                            ngbDatepicker #appointment="ngbDatepicker" data-date-inline-picker="false"
                            id="appointmentDate" [maxDate]="maxDates" [minDate]="currentDate"
                            (dateSelect)="getTimeSlots()" [markDisabled]="disableWeekends"/>
                          <div>
                            <button class="btn btn-outline-secondary button-height calendar rounded-0"
                              (click)="appointment.toggle()" type="button" id="AppointmentButton">
                              <img src="/assets/images/cal.png" />
                            </button>
                          </div>
                        </div>
                        <!-- <div *ngIf="patientForm.get('apdate').hasError('required')" class="invalid-feedback">
                          Appointment Date is required
                        </div>
                        <div *ngIf="
                            !patientForm.get('apdate').hasError('required') &&
                            patientForm.get('apdate').hasError('ngbDate')
                          " class="invalid-feedback">
                          Appointment Date is invalid
                        </div> -->
                        <div class="text-danger"
                          *ngIf="  patientForm.get('apdate').touched && patientForm.get('apdate').invalid">
                          *Appointment Date is invalid
                        </div>
                      </div>
                    </div>
                    <div class="row pt-3" *ngIf="timeSlots?.length">
                      <div class="col-lg-12 mb-3">
                        Select from the following available Timeslots<span class="text-danger">*</span>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-check form-check-inline" *ngFor="let t of timeSlots; let i = index">
                          <label class="form-check-label" for="{{ i }}">
                            <span class="btn btn-primary" [ngClass]="{ 'btn-success': isSelectedItem(i) }">{{
                              t.start_time }}</span>
                          </label>
                          <input type="radio" name="appointmentTime" class="form-check-input invisible"
                            value="{{ t.start_time }}" id="{{ i }}" (change)="TimeSlotSelected(i)" [(ngModel)]="aptime"
                            [ngModelOptions]="{ standalone: true }" />
                        </div>
                        <div *ngIf="patientForm.get('aptime').hasError('required')" class="invalid-feedback">
                          Appointment Time is required
                        </div>
                      </div>
                    </div>
                    <div *ngIf="
                        (!patientId && isFollowup) ||
                        !patientId ||
                        (patientId && isFollowup)
                      " class="row pt-3">
                      <div class="col-md-6">
                        <label for="phone" class="text-change font-weight-500">Your Phone<span
                            class="text-danger">*</span></label>
                        <input type="text" class="form-control" formControlName="contact_no" maxLength="10"
                          minLength="10" required on-focusout="requestOTP()" />
                        <!-- <div *ngIf="
                            patientForm.get('contact_no').hasError('required')
                          " class="invalid-feedback">
                          Phone is required
                        </div>
                        <div *ngIf="
                            patientForm.get('contact_no').hasError('pattern') ||
                            patientForm.get('contact_no').hasError('minlength')
                          " class="invalid-feedback">
                          Phone is invalid
                        </div> -->
                        <div class="text-danger"
                          *ngIf="  patientForm.get('contact_no').touched && patientForm.get('contact_no').invalid">
                          *Phone is invalid
                        </div>
                      </div>
                    </div>
                    <div *ngIf="
                        (!patientId && isFollowup) ||
                        !patientId ||
                        (patientId && isFollowup)
                      " class="row pt-3">
                      <div class="col-md-6">
                        <label class="font-weight-500">OTP<span class="text-danger">*</span></label>
                        <input type="password" class="form-control" formControlName="otp" maxLength="6" required
                          on-focusout="validateOTP()" autocomplete="new-password" />
                        <!-- <div *ngIf="
                            patientForm.get('otp').touched &&
                            patientForm.get('otp').hasError('required')
                          " class="invalid-feedback">
                          OTP is required
                        </div>
                        <div *ngIf="patientForm.get('otp').touched && wrongOTP" class="invalid-feedback">
                          OTP is invalid
                        </div> -->
                        <div class="text-danger"
                          *ngIf="  patientForm.get('otp').touched && patientForm.get('otp').invalid">
                          *OTP is required
                        </div>
                      </div>
                    </div>
                    <div class="row pt-3">
                      <div class="col-md-12">
                        <div>
                          <label class="font-weight-500">Do you have any drug allergies?<span
                              class="text-danger">*</span></label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input mb-0" type="radio" name="drug_allergy" id="inlineRadio1"
                            value="yes" formControlName="drug_allergy" />
                          <label class="form-check-label m-0" for="inlineRadio1">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input mb-0" type="radio" name="drug_allergy" id="inlineRadio2"
                            value="no" formControlName="drug_allergy" />
                          <label class="form-check-label m-0" for="inlineRadio2">No</label>
                        </div>
                        <div *ngIf="patientForm.value.drug_allergy === 'yes'" class="mt-2">
                          <em>In Concern section, Please provide detailed
                            information about your allergies as well.</em>
                        </div>
                        <div *ngIf="
                            patientForm.get('drug_allergy').hasError('required')
                          " class="invalid-feedback">
                          This is required
                        </div>
                      </div>
                    </div>
                    <div class="row pt-3">
                      <div class="col-md-12">
                        <label class="font-weight-500">Concern<span class="text-danger">*</span></label>
                        <textarea class="form-control" formControlName="remarks" maxLength="300" required></textarea>
                        <div *ngIf="
                            patientForm.get('remarks').hasError('required')
                          " class="invalid-feedback">
                          Concern is required
                        </div>
                      </div>
                    </div>
                    <div class="form-check d-flex" *ngIf="!loggedInPatient && !isFollowup && disableCheckbok=== false">
                      <input class="form-check-input" type="checkbox" (change)="createAccountCheck($event)"
                        id="defaultCheck1" />
                      <label class="form-check-label" for="defaultCheck1">
                        Click here to create an account. Temporary password will
                        be sent to your email id. You can use your account to
                        book appointments for your self and family members,
                        check appointment details , consultation summary and
                        prescription anytime
                      </label>
                    </div>
                    <div class="form-check pt-3">
                      <input type="checkbox" class="form-check-input" id="termsnCondition" (change)="tacChecked($event)"
                        required />
                      <label class="form-check-label ml-2" for="termsnCondition">I accept<a href="{{ termsUrl }}"
                          target="_blank" class="text-primary">
                          terms and condition</a></label>
                    </div>
                    <div class="row pt-3 d-flex" *ngIf="
                        validOTP &&
                        physician.consult_fee > 0 &&
                        patientId &&
                        allCouponDetails
                      ">
                      <label class="text-color font-size-15 font-weight-500 mt-3 ml-3">Apply Discount Coupon
                      </label>
                      <select class="form-control ml-3 col-md-3 font-size-15" formControlName="couponSelected"
                        (change)="calculateRevisedAmount()">
                        <option value="">Not Selected</option>
                        <option *ngFor="let couponRecord of allCouponDetails" [ngValue]="couponRecord">
                          {{ couponRecord.id }} -
                          {{ couponRecord.description }} -
                          {{ couponRecord.discount_percent }} %
                        </option>
                      </select>
                      <div class="col-md-5" *ngIf="patientForm.get('couponSelected').value">
                        <div class="d-flex">
                          <label class="text-color text-change text-right font-weight-500 col-md-9 mt-3">REVISED
                            CHARGES: Rs
                          </label>
                          <!--<input type="text text-right" class="form-control col-md-4"
                            formControlNmae="revisedChargeField" disabled [value]="revisedCharge">-->
                          <label class="col-md-4 mt-2 ml-2 font-weight-500 font-size-20 border pt-2 pb-2"
                            style="border: 5px">{{ revisedCharge }}</label>
                        </div>

                        <div class="invalid-feedback text-right" style="color: green">
                          You saved Rs
                          <strong>{{ amountSaved }}</strong>
                        </div>
                      </div>
                    </div>

                    <div class="row pt-3">
                      <div class="col-md-12">
                        <label>
                          <i>You can upload reports and documents once your
                            appointment is approved.</i></label>
                      </div>
                    </div>

                    <div class="row pt-3">
                      <div class="col-md-12">
                        <button type="button" class="btn btn-primary w-100" [disabled]="
                            patientForm.invalid || !validOTP || tAndC == false
                          " (click)="pay()">
                          PAY AND CONFIRM
                        </button>
                        <!-- <button type="button" class="btn btn-primary w-100" (click)="pay()">
                          PAY AND CONFIRM
                        </button> -->
                      </div>
                    </div>
                  </fieldset>
                </form>
              </div>
              <div class="col-md-5">
                <!-- <h4 class="support-block-title ml-0 ml-md-3 para-color">Consultation charges ₹
                  {{physician?.consult_fee}}</h4> -->
                <img src="assets/images/appt-banner.svg" class="w-100 ml-0 ml-md-1" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center" *ngIf="!physician && !loading">
      <div class="col-lg-10">
        <div class="card m-b-30">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 mt-2 text-center">
                <h5 class="text-danger">NO PHYSICIAN FOUND</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer-new></app-footer-new>
</div>


<ng-template #confirmationModal let-modal>
  <!-- Modal content -->
  <div class="modal-body">
    <span class="close" (click)="modal.dismiss(false)">&times;</span>
    <div class="row center-mobile">
      <div class="col-md-4 m-l-60 m12">
        <i class="fa fa-heartbeat heartbeat" style="font-size: 75px; color: #dc3648; margin-left: 25px;"
          aria-hidden="true"></i>
      </div>
      <div class="col-md-8 m-l-10 m12">
        <p style="margin-bottom: 5px;">Your account already exist you can continue login</p>

        <div class="row">
          <div class="btnwrap">
            <span>
              <button type="button" class="btn btn-model" (click)="modal.dismiss(false)"
                style="background-color: #6f717d; color: white; margin-right: 10px;     margin-left: 15px;"> No
              </button>
            </span>
            <span>
              <a href=".#/login"> <button type="button" class="btn btn-primary btn-model"
                  (click)="modal.dismiss(false)"> Yes </button></a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>